// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
// Iter 44 — direct Google OAuth 2.0 (authorization code flow) using the
// project's own Google Cloud Client ID. The Client Secret is server-side only.
import { Chrome } from "lucide-react";

export default function GoogleLoginButton({ label = "Continue with Google", testid = "google-login-btn" }) {
    const startGoogle = () => {
        const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
        if (!clientId) {
            // Fail loud so the misconfig is spotted immediately instead of a
            // silent no-op click that looks like a broken button.
            alert("Google Sign-In is not configured (missing REACT_APP_GOOGLE_CLIENT_ID). Contact support.");
            return;
        }
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const redirectUri = window.location.origin + "/auth/callback";
        const params = new URLSearchParams({
            client_id: clientId,
            redirect_uri: redirectUri,
            response_type: "code",
            scope: "openid email profile",
            access_type: "online",
            include_granted_scopes: "true",
            prompt: "select_account",
        });
        window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
    };
    return (
        <button
            type="button"
            onClick={startGoogle}
            data-testid={testid}
            className="w-full h-11 inline-flex items-center justify-center gap-2 bg-white text-slate-900 font-bold uppercase tracking-widest text-xs rounded hover:bg-slate-100 transition-colors active:scale-[0.99]"
        >
            <Chrome className="w-4 h-4" />
            {label}
        </button>
    );
}
